(() => {
  'use strict';
  // Availability is Shopify's native value; inventory quantities are never inferred here.
  function consistent(state) {
    const variant = state?.variant;
    return state?.coreReady === true && variant?.available === true
      && /^[1-9]\d*$/.test(String(state.productId))
      && String(state.productId) === String(state.nativeProductId)
      && /^[1-9]\d*$/.test(String(variant.id)) && String(variant.id) === String(state.formVariantId)
      && Array.isArray(variant.options) && Array.isArray(state.selected)
      && state.selected.length > 0 && variant.options.length === state.selected.length
      && state.selected.every((value, index) => value !== null && String(value) === String(variant.options[index]));
  }
  function variantForMedia(variants, mediaId) {
    if (!Array.isArray(variants) || !/^[1-9]\d*$/.test(String(mediaId))) return null;
    const matches = variants.filter(variant => String(variant.featured_media?.id) === String(mediaId));
    return matches.length === 1 && matches[0].available === true ? matches[0] : null;
  }
  if (typeof module === 'object' && module.exports) module.exports = {consistent, variantForMedia};
  if (typeof window === 'undefined' || customElements.get('aroha-relief-buy-guard')) return;
  class ReliefBuyGuard extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info');
      this.gate = this.querySelector('[data-relief-buy-gate]');
      this.help = this.querySelector('[data-relief-buy-help]');
      this.form = this.querySelector('form');
      this.onChoice = event => {
        if (event.target?.closest('variant-selects')?.closest('product-info') === this.info) this.lock();
      };
      this.onSubmit = event => {
        if (!this.refresh()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      };
      this.onThumbnail = event => { try { this.syncThumbnail(event); } catch (_) { this.lock(); } };
      this.info?.addEventListener('change', this.onChoice, true);
      this.info?.addEventListener('click', this.onThumbnail, true);
      this.form?.addEventListener('submit', this.onSubmit, true);
      this.timer = setInterval(() => this.refresh(), 200);
      this.refresh();
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.info?.removeEventListener('change', this.onChoice, true);
      this.info?.removeEventListener('click', this.onThumbnail, true);
      this.form?.removeEventListener('submit', this.onSubmit, true);
      this.lock();
    }
    lock() {
      if (this.gate) this.gate.disabled = true;
      if (this.help) this.help.hidden = false;
    }
    snapshot() {
      const picker = this.info?.querySelector('variant-selects');
      const host = this.querySelector('product-form');
      const variant = JSON.parse(picker?.querySelector('[data-selected-variant]')?.textContent || 'null');
      const groups = [...(picker?.querySelectorAll('fieldset') || [])];
      const selected = groups.length
        ? groups.map(group => group.querySelector('input:checked')?.value ?? null)
        : [...(picker?.querySelectorAll('select') || [])].map(select => select.value);
      return {
        productId: this.dataset.productId,
        nativeProductId: this.info?.dataset.productId,
        formVariantId: this.form?.querySelector('input[name="id"]')?.value,
        variant, selected,
        coreReady: !!(customElements.get('product-info') && customElements.get('product-form') && customElements.get('variant-selects')
          && typeof this.info?.onVariantChangeUnsubscriber === 'function'
          && typeof this.info?.handleOptionValueChange === 'function'
          && typeof picker?.updateSelectionMetadata === 'function'
          && host?.form === this.form && host?.submitButton && typeof host?.onSubmitHandler === 'function')
      };
    }
    syncThumbnail(event) {
      const thumbnail = event.target?.closest('button.thumbnail');
      if (!thumbnail || thumbnail.closest('product-info') !== this.info || !thumbnail.closest('media-gallery')) return;
      const target = thumbnail.closest('[data-target]')?.dataset.target;
      const prefix = this.info.dataset.section + '-';
      if (!target?.startsWith(prefix) || !this.snapshot().coreReady) return;
      const variants = JSON.parse(this.querySelector('[data-relief-variants]')?.textContent || 'null');
      const variant = variantForMedia(variants, target.slice(prefix.length));
      if (!variant || !Array.isArray(variant.options)) return;
      const picker = this.info.querySelector('variant-selects');
      const groups = [...picker.querySelectorAll('fieldset')];
      if (groups.length !== variant.options.length) return;
      const inputs = groups.map((group, index) => [...group.querySelectorAll('input[type="radio"]')].find(input => input.value === variant.options[index] && !input.disabled));
      if (inputs.some(input => !input)) return;
      const changed = inputs.filter(input => !input.checked);
      if (!changed.length) return;
      this.lock();
      inputs.forEach(input => { input.checked = true; });
      // One native change observes the complete pair; Shopify owns the fetch,
      // URL, media and hidden variant-ID update, including rapid-change aborts.
      changed[changed.length - 1].dispatchEvent(new Event('change', {bubbles:true}));
    }
    refresh() {
      try {
        const state = this.snapshot();
        const ready = !!this.gate && !!this.form && consistent(state);
        const note = this.querySelector('[data-relief-selected-note]');
        if (note && state.selected.length === 2 && state.selected.every(value => value !== null)) {
          const text = `Your choice: ${state.selected[0]} background · ${state.selected[1]} frame.`;
          if (note.textContent !== text) note.textContent = text;
        }
        if (this.gate) this.gate.disabled = !ready;
        if (this.help) this.help.hidden = ready;
        return ready;
      } catch (_) { this.lock(); return false; }
    }
  }
  customElements.define('aroha-relief-buy-guard', ReliefBuyGuard);
})();
